<template>
  <v-app>
    <div class="top">
      <section class="advantages" v-if="!isSolar">
        <p class="advantages__items">
          <i class="fas fa-credit-card"></i> PARCELAMENTO EM ATÉ 10x SEM JUROS NO
          CARTÃO
        </p>
        <p class="advantages__items">
          <i class="fas fa-percent"></i> 5% OFF NO BOLETO À VISTA
        </p>
        <p class="advantages__items">
          <i class="fas fa-truck"></i> ENTREGA EM TODO BRASIL
        </p>
        <p class="advantages__items">
          <i class="far fa-address-card"></i> 45 ANOS DE TRADIÇÃO
        </p>
        <p class="advantages__items">
          <i class="fas fa-smile-beam"></i> EXCELÊNCIA RECLAME AQUI 1000
        </p>
      </section>

      <section class="advantages" v-if="isSolar">
        <p class="advantages__items">
          <i class="fas fa-percent"></i> 2% OFF NO BOLETO À VISTA
        </p>
        <p class="advantages__items">
          <i class="fas fa-truck"></i> ENTREGA EM TODO BRASIL
        </p>
        <p class="advantages__items">
          <i class="far fa-address-card"></i> 45 ANOS DE TRADIÇÃO
        </p>
        <p class="advantages__items">
          <i class="fas fa-smile-beam"></i> EXCELÊNCIA RECLAME AQUI 1000
        </p>

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <p class="advantages__items" v-bind="attrs" v-on="on">
              <i class="fas fa-sun"></i> {{ saleChannel[0].NomeCanal }}
            </p>
          </template>
          <v-list>
            <v-list-item
              style="cursor: pointer;"
              v-for="(item, index) in salesChannel"
              :key="index"
              link
            >
              <v-list-item-title @click="changeChannel(item)">{{ item.NomeCanal }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </section>

      <header class="headerMenu">
        <div class="header">
          <div class="header__iconMenu" @click="menuMobile">
            <div class="menuHamburguer"></div>
            <div class="menuHamburguer"></div>
            <div class="menuHamburguer"></div>
          </div>
          <div class="header__logo">
            <router-link to="/">
              <img
                loading="lazy"
                src="../../assets/logo_integra.png"
                alt="Logo Profiz Leveros Integra"
            /></router-link>
          </div>
          <div class="header__search">
            <input
              type="text"
              class="header__inputSearch"
              placeholder="Buscar por nome do produto ou SKU"
              v-model="descricao"
              @change="getProduct"
              @click="addOverlay"
            />
            <button class="header__buttonSearch" @click="getProduct">
              <img
                loading="lazy"
                src="../../assets/icon_search.png"
                alt="Pesquisar pelo nome do produto ou SKU"
              />
            </button>
            <div id="backgroundOverlay" @click="closeOverlay"></div>
            <div class="result">
              <div
                class="result__item"
                v-for="(infos, i) in infoSKU.slice(0, 6)"
                :key="i"
              >
                <a
                  @click="
                    productDetails(
                      infos.Nr_TabelaPrecoItem,
                      infos.vl_liquido_produto,
                      infos.isCustomized
                    )
                  "
                >
                  <img :src="infos.ImagemItem" :alt="infos.Ds_Item" />
                  <p>{{ infos.Ds_Item }}</p>
                </a>
              </div>
              <p class="result__void">Produto não encontrado!</p>
            </div>
          </div>
          <div class="header__account">
            <router-link to="/account/orders">
              <img
                loading="lazy"
                src="../../assets/icon_account.png"
                alt="Acessar Meu Perfil"
              />
            </router-link>
            <div class="header__guest" v-if="nomeUsuario == null">
              <div class="header__guestOptions">
                <p>OLÁ VISITANTE</p>
                <p>
                  Faça <router-link to="/login">Login</router-link> ou
                  <router-link to="/register">Cadastre-se</router-link>
                </p>
              </div>
            </div>

            <div class="header__user" v-if="nomeUsuario != null">
              <p>OLÁ {{ nomeUsuario }}</p>
              <div class="header__userOptions">
                <span
                  ><router-link to="/account/orders"
                    >Minha conta</router-link
                  ></span
                >
                <span> ou </span>
                <span class="header__logout" @click="deleteAllCookies">sair</span>
              </div>
            </div>
          </div>
          <div class="header__cart" @click="openMiniCart">
            <img
              loading="lazy"
              src="../../assets/icon_cart.png"
              alt="Abrir Meu carrinho"
            />
            <span class="header__quantity">{{ totalItensCarrinho }}</span>
            <div class="header__cartGroup">
              <p>CARRINHO</p>
              <p>{{ totalCarrinho | toCurrency }}</p>
            </div>
          </div>
        </div>

        <div class="minicart">
          <div class="minicart__header">
            <h3>Meu Carrinho</h3>
            <i
              class="fa fa-times minicart__closeMiniCart"
              aria-hidden="true"
              @click="closeMiniCart"
            ></i>
          </div>
          <div class="minicart__products">
            <div class="minicart__item" v-for="item in carrinho" :key="item.sku">
              <div class="minicart__image">
                <a href=""
                  ><img
                    loading="lazy"
                    :src="item.imagem"
                    width="90px"
                    :alt="item.nomeItem"
                /></a>
              </div>
              <div class="minicart__details">
                <p>
                  {{ item.nomeItem }}
                </p>
                <p>{{ parseFloat(item.valor) | toCurrency }}</p>
                <button v-if="!item.isCustomized" @click="diminuirItensCarrinho(item.sku)">-</button>
                <span v-if="item.isCustomized">Quantidade:</span><span>{{ item.quantidade }}</span>
                <button v-if="!item.isCustomized" @click="aumentarItensCarrinho(item.sku, item.estoque)">
                  +
                </button>
                <div v-if="!item.isCustomized">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div>
                        <p style="cursor: pointer;" v-bind="attrs" v-on="on">
                          Disponível: <b>{{ item.estoque }}</b>
                        </p>
                        
                      </div>
                    </template>
                    <span>Para maiores quantidades contatar seu consultor de vendas</span>
                  </v-tooltip>
                </div>

                
              </div>
              <div class="minicart__iconTrash">
                <a
                  href="javascript:void(0)"
                  @click="excluirProdutoCarrinho(item.sku)"
                  ><i class="far fa-trash-alt"></i
                ></a>
              </div>
            </div>
          </div>
          <div class="minicart__shipping">
            <div class="minicart__title">
              <h3>Calcular Frete</h3>
            </div>
            <div class="minicart__calculate">
              <the-mask
                mask="#####-###"
                v-model="cep"
                type="text"
                placeholder="Informe seu CEP"
                :masked="false"
                @change="calcularFrete"
                class="minicart__input"
              />
              <button class="minicart__buttonSearch" @click="calcularFrete">
                <img
                  loading="lazy"
                  src="../../assets/icon_search.png"
                  alt="Calcular Frete"
                />
              </button>
              <p class="minicart__toKnowCEP">
                <a
                  href="https://buscacepinter.correios.com.br/app/localidade_logradouro/index.php"
                  target="_blank"
                  rel="noopener"
                  >Não sei meu CEP</a
                >
              </p>
            </div>
            <div class="minicart__options">
              <div class="minicart__loader" v-if="loader">
                <span><i class="fas fa-stroopwafel fa-spin fa-3x"></i></span>
                <span>Calculando frete...</span>
              </div>

              <v-radio-group v-if="!loader">
                <v-radio
                  v-for="s in sla"
                  :key="s.tipo"
                  :label="s.textoFrete"
                  @change="selecionaSLA(s)"
                  :value="s.sla"
                ></v-radio>
              </v-radio-group>
            </div>
          </div>
          <div class="minicart__totals">
            <ul>
              <li>
                <strong>SUBTOTAL</strong>
                <span> {{ totalCarrinho | toCurrency }}</span>
              </li>
              <li>
                <strong>FRETE</strong>
                <span v-if="slaSelecionado == null">A Calcular</span>
                <span v-if="slaSelecionado != null">
                  {{ slaSelecionado.preco | toCurrency }}</span
                >
              </li>
              <li>
                <strong>TOTAL</strong>
                <span v-if="slaSelecionado != null">
                  {{ (totalCarrinho + slaSelecionado.preco) | toCurrency }}</span
                >
                <span v-if="slaSelecionado == null">
                  {{ totalCarrinho | toCurrency }}</span
                >
              </li>
            </ul>
          </div>
          <div class="minicart__buttons">
            <router-link to="/checkout/cart">
              <button class="minicart__buttons minicart__buttons--cart">
                Ver Carrinho
              </button>
            </router-link>
            <router-link to="/checkout">
              <button class="minicart__buttons minicart__buttons--buy">
                FINALIZAR COMPRA
              </button>
            </router-link>
          </div>
        </div>

        <nav class="navbar" v-if="!isSolar">
          <ul class="nav">
            <li class="nav__item">
              <a href="#" class="nav__link">
                <img
                  loading="lazy"
                  src="../../assets/icon_hamburguer.png"
                  width="30px"
                  height="30px"
                  alt="Abrir Departamentos"
                />
                <span class="nav__title">Departamentos</span>
              </a>

              <div class="submenuDepartment">
                <div class="submenuDepartment__items">
                  <div class="submenuDepartment__group">
                    <h3 class="submenuDepartment__title">Ar-Condicionado</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Inverter"
                          >Inverter</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=%2aSplit"
                          >Convencional</a
                        >
                      </li>
                      <li class="menu__item">
                        <a
                          class="menu__link"
                          href="/product?Categoria=Multi%20Split"
                          >Multi Split</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Cassete"
                          >Cassete</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Piso Teto"
                          >Piso Teto</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Portátil"
                          >Ar Portátil</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Janela"
                          >Ar Janela</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=%2aDuto"
                          >Duto</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=%2aSplitão"
                          >Splitão</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=%2aVRF"
                          >VRF</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenuDepartment__group">
                    <h3 class="submenuDepartment__title">Eletrodomésticos</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a
                          href="/product?Categoria=%2aFrigobar"
                          class="menu__link"
                          >Frigobar</a
                        >
                      </li>
                      <li class="menu__item">
                        <a href="/product?Categoria=%2aCooktop" class="menu__link"
                          >Cooktop</a
                        >
                      </li>
                      <li class="menu__item">
                        <a
                          href="/product?Categoria=%2aCervejeira"
                          class="menu__link"
                          >Cervejeira</a
                        >
                      </li>
                      <li class="menu__item">
                        <a
                          href="/product?Categoria=%2aPurificador%20de%20Água"
                          class="menu__link"
                          >Purificador de Água</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenuDepartment__group">
                    <h3>Ventiladores</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a href="/product?Categoria=Ventilador" class="menu__link"
                          >Mesa</a
                        >
                      </li>
                      <li class="menu__item">
                        <a href="/product?Categoria=Ventilador" class="menu__link"
                          >Teto</a
                        >
                      </li>
                      <li class="menu__item">
                        <a href="/product?Categoria=Ventilador" class="menu__link"
                          >Parede</a
                        >
                      </li>
                      <li class="menu__item">
                        <a href="/product?Categoria=Ventilador" class="menu__link"
                          >Coluna</a
                        >
                      </li>
                      <li class="menu__item">
                        <a href="/product?Categoria=Ventilador" class="menu__link"
                          >Circulador</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenuDepartment__group">
                    <h3>Climatização</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a
                          href="/product?Categoria=Climatizador%20Industrial"
                          class="menu__link"
                          >Climatizador Industrial</a
                        >
                      </li>
                      <li class="menu__item">
                        <a
                          href="/product?Categoria=Climatizador%20Residencial"
                          class="menu__link"
                          >Climatizador Residencial</a
                        >
                      </li>
                      <li class="menu__item">
                        <a
                          href="/product?Categoria=%2aCortina%20de%20Ar"
                          class="menu__link"
                          >Cortina de Ar</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenuDepartment__group">
                    <h3>Serviços</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a
                          href="/product?Categoria=Instalação%20de%20Ar-condicionado"
                          class="menu__link"
                          >Instalação de Ar-Condicionado</a
                        >
                      </li>
                      <li class="menu__item">
                        <a href="/product?Categoria=Serviço" class="menu__link"
                          >Limpeza de Ar-Condicionado</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenuDepartment__group">
                    <h3>Acessórios</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a
                          href="/product?Categoria=%2aSuporte%20Ar-condicionado"
                          class="menu__link"
                          >Suporte de Ar-Condicionado</a
                        >
                      </li>
                      <li class="menu__item">
                        <a href="/product?Categoria=Outros" class="menu__link"
                          >Kit de Instalação</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenuDepartment__group">
                    <h3>Ferramentas</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a
                          href="/product?Categoria=Instrumentos%20de%20medição"
                          class="menu__link"
                          >Ferramentas</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenuDepartment__group">
                    <h3>Aquecedores de Água a Gás</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a
                          href="/product?Categoria=%2aAquecedor"
                          class="menu__link"
                          >Aquecedor de Água a Gás</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenuDepartment__group">
                    <h3>Automação Residencial</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a
                          href="/product?Categoria=%2aAutomação%20Residencial"
                          class="menu__link"
                          >Automação Residencial</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
            <li class="nav__item">
              <a class="nav__link" href="/product?Categoria=Inverter">
                <img
                  loading="lazy"
                  src="../../assets/icon-home-inverter.png"
                  alt="Categoria Ar-Condicionado Inverter"
                />

                <span class="nav__title">Inverter</span>
              </a>

              <!-- <div class="submenu">
                <div class="submenu__items">
                  <div class="submenu__group">
                      <h3>Capacidade</h3>
                      <ul>
                      <li class="menu__item">
                        <a href="/product?Categoria=Inverter&Capacidade=7000-9000" class="menu__link"
                          >9.000 BTUs</a
                        >
                      </li>
                      <li class="menu__item">
                        <a
                          href="/product?Categoria=Inverter&Capacidade=9001-12000" class="menu__link"
                          >12.000 BTUs</a
                        >
                      </li>
                      <li class="menu__item">
                        <a
                          href="/product?Categoria=Inverter&Capacidade=12001-18000" class="menu__link"
                          >18.000 BTUs</a
                        >
                      </li>
                      <li class="menu__item">
                        <a
                          href="/product?Categoria=Inverter&Capacidade=18001-24000" class="menu__link"
                          >24.000 BTUs</a
                        >
                      </li>
                      <li class="menu__item">
                        <a
                          href="/product?Categoria=Inverter&Capacidade=24001-36000" class="menu__link"
                          >36.000 BTUs</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenu__group">
                    </div>
                  <div class="submenu__group">
                    <h3>Ciclo</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a href="/product?Categoria=Inverter&Ciclo=Frio" class="menu__link">Frio</a>
                      </li>
                      <li class="menu__item">
                        <a
                          href="/product?Categoria=Inverter&Ciclo=Quente%20e%20Frio" class="menu__link"
                          >Quente e Frio</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div> -->
            </li>
            <li class="nav__item">
              <a class="nav__link" href="/product?Categoria=%2aSplit">
                <img
                  loading="lazy"
                  src="../../assets/icon-home-parede.png"
                  alt="Categoria Ar-Condicionado Convencional"
                />

                <span class="nav__title">Convencional</span>
              </a>

              <!-- <div class="submenu">
                <div class="submenu__items">
                  <div class="submenu__group">
                    <h3>Capacidade</h3>
                    <ul class="menu">
                    <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=%2aSplit&Capacidade=7000-9000"
                          >9.000 BTUs</a
                        >
                      </li>
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=%2aSplit&Capacidade=9001-12000"
                          >12.000 BTUs</a
                        >
                      </li>
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=%2aSplit&Capacidade=12001-18000"
                          >18.000 BTUs</a
                        >
                      </li>
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=%2aSplit&Capacidade=18001-24000"
                          >24.000 BTUs</a
                        >
                      </li>
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=%2aSplit&Capacidade=24001-36000"
                          >36.000 BTUs</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenu__group">
                    <h3>Marca</h3>
                    <ul class="menu">
                  <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=%2aSplit&Marca=%2aAgratto"
                          >Agratto</a
                        >
                      </li>
                    <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=%2aSplit&Marca=%2aComfee"
                          >Comfee</a
                        >
                      </li>
                    <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=%2aSplit&Marca=%2aElgin"
                          >Elgin</a
                        >
                      </li>
                    <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=%2aSplit&Marca=%2aGree"
                          >Gree</a
                        >
                      </li>
                    <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=%2aSplit&Marca=%2aMaxiflex"
                          >Maxiflex</a
                        >
                      </li>
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=%2aSplit&Marca=%2aSpringer%20Midea"
                          >Springer Midea</a
                        >
                      </li>
                    <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=%2aSplit&Marca=%2aTrane"
                          >Trane</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenu__group">
                    <h3>Ciclo</h3>
                    <ul class="menu">
                    <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=%2aSplit&Ciclo=Frio">Frio</a>
                      </li>
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=%2aSplit&Ciclo=Quente%20e%20Frio"
                          >Quente e Frio</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div> -->
            </li>
            <li class="nav__item">
              <a class="nav__link" href="/product?Categoria=Inverter">
                <img
                  loading="lazy"
                  src="../../assets/icon-home-multi.png"
                  alt="Categoria Ar-Condicionado Multi Split"
                />

                <span class="nav__title">Multi Split</span>
              </a>

              <!-- <div class="submenu">
                <div class="submenu__items">
                  <div class="submenu__group">
                    <h3>Ambientes</h3>
                    <ul class="menu">
                  <li class="menu__item"><a class="menu__link" href="">2 Ambientes</a></li>
                    <li class="menu__item"><a class="menu__link" href="">3 Ambientes</a></li>
                    <li class="menu__item"><a class="menu__link" href="">4 Ambientes</a></li>
                    <li class="menu__item"><a class="menu__link" href="">5 Ambientes</a></li>
                    <li class="menu__item"><a class="menu__link" href="">6 Ambientes</a></li>
                    </ul>
                  </div>
                  <div class="submenu__group">
                    <h3>Marca</h3>
                    <ul class="menu">
                      <li class="menu__item"><a class="menu__link" href="">Daikin</a></li>
                      <li class="menu__item"><a class="menu__link" href="">Fujitsu</a></li>
                      <li class="menu__item"><a class="menu__link" href="">LG</a></li>
                      <li class="menu__item"><a class="menu__link" href="">Springer Midea</a></li>
                      <li class="menu__item"><a class="menu__link" href="">Trane</a></li>
                    </ul>
                  </div>
                </div>
              </div> -->
            </li>
            <li class="nav__item">
              <a class="nav__link" href="/product?Categoria=Janela">
                <img
                  loading="lazy"
                  src="../../assets/icon-home-janela.png"
                  alt="Categoria Ar-Condicionado Janela"
                />

                <span class="nav__title">Ar Janela</span>
              </a>

              <!-- <div class="submenu">
                <div class="submenu__items">
                  <div class="submenu__group">
                    <h3>Capacidade</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Janela&Capacidade=7000-7500"
                          >7.500 BTUs</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Janela&Capacidade=7501-10000"
                          >10.000 BTUs</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Janela&Capacidade=10001-12000"
                          >12.000 BTUs</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Janela&Capacidade=12001-18000"
                          >18.000 BTUs</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Janela&Capacidade=18001-20000"
                          >20.000 BTUs</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Janela&Capacidade=20001-27000"
                          >27.000 BTUs</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenu__group">
                    <h3>Marca</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=Janela&Marca=%2aSpringer%20Midea"
                          >Springer Midea</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenu__group">
                    <h3>Ciclo</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Janela&Ciclo=Frio">Frio</a>
                      </li>
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=Janela&Ciclo=Quente%20e%20Frio"
                          >Quente e Frio</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div> -->
            </li>
            <li class="nav__item">
              <a class="nav__link" href="/product?Categoria=Cassete">
                <img
                  loading="lazy"
                  src="../../assets/icon-home-cassete.png"
                  alt="Categoria Ar-Condicionado Cassete"
                />

                <span class="nav__title">Cassete</span>
              </a>

              <!-- <div class="submenu">
                <div class="submenu__items">
                  <div class="submenu__group">
                    <h3>Capacidade</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=Cassete&Capacidade=17000-30000"
                          >17.000 BTUs a 30.000 BTUs</a
                        >
                      </li>
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=Cassete&Capacidade=31000-35000"
                          >31.000 BTUs a 35.000 BTUs</a
                        >
                      </li>
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=Cassete&Capacidade=36000-48000"
                          >36.000 BTUs a 48.000 BTUs</a
                        >
                      </li>
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=Cassete&Capacidade=49000-54000"
                          >49.000 BTUs a 54.000 BTUs</a
                        >
                      </li>
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=Cassete&Capacidade=55000-80000"
                          >55.000 BTUs a 80.000 BTUs</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenu__group">
                    <h3>Marca</h3>
                    <ul class="menu">
                  <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Cassete&Marca=%2aCarrier"
                          >Carrier</a
                        >
                      </li>
                  <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Cassete&Marca=%2aDaikin"
                          >Daikin</a
                        >
                      </li>
                  <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Cassete&Marca=%2aElgin"
                          >Elgin</a
                        >
                      </li>
                  <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Cassete&Marca=%2aFujitsu"
                          >Fujitsu</a
                        >
                      </li>
                  <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Cassete&Marca=%2aLG">LG</a>
                      </li>
                  <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Cassete&Marca=%2aTrane"
                          >Trane</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenu__group">
                    <h3>Ciclo</h3>
                    <ul class="menu">
                    <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Cassete&Ciclo=Frio">Frio</a>
                      </li>
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=Cassete&Ciclo=Quente%20e%20Frio"
                          >Quente e Frio</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div> -->
            </li>
            <li class="nav__item">
              <a class="nav__link" href="/product?Categoria=Piso%20Teto">
                <img
                  loading="lazy"
                  src="../../assets/icon-home-piso-teto.png"
                  alt="Categoria Ar-Condicionado Piso Teto"
                />

                <span class="nav__title">Piso Teto</span>
              </a>

              <!-- <div class="submenu">
                <div class="submenu__items">
                  <div class="submenu__group">
                    <h3>Capacidade</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=Piso%20Teto&Capacidade=12000-17000"
                          >12.000 BTUs a 17.000 BTUs</a
                        >
                      </li>
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=Piso%20Teto&Capacidade=18000-24000"
                          >18.000 BTUs a 24.000 BTUs</a
                        >
                      </li>
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=Piso%20Teto&Capacidade=30000-48000"
                          >30.000 BTUs a 48.000 BTUs</a
                        >
                      </li>
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=Piso%20Teto&Capacidade=51000-80000"
                          >51.000 BTUs a 80.000 BTUs</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenu__group">
                    <h3>Marca</h3>
                    <ul class="menu">
                    <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Piso%20Teto&Marca=%2aAgratto"
                          >Agratto</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Piso%20Teto&Marca=%2aCarrier"
                          >Carrier</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Piso%20Teto&Marca=%2aElgin"
                          >Elgin</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Piso%20Teto&Marca=%2aFujitsu"
                          >Fujitsu</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Piso%20Teto&Marca=%2aGree"
                          >Gree</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Piso%20Teto&Marca=%2aLG"
                          >LG</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Piso%20Teto&Marca=%2aMaxiflex"
                          >Maxiflex</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Piso%20Teto&Marca=%2aSpringer"
                          >Springer</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Piso%20Teto&Marca=%2aTrane"
                          >Trane</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenu__group">
                    <h3>Ciclo</h3>
                    <ul class="menu">
                    <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Piso%20Teto&Ciclo=Frio"
                          >Frio</a
                        >
                      </li>
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=Piso%20Teto&Ciclo=Quente%20e%20Frio"
                          >Quente e Frio</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div> -->
            </li>
            <li class="nav__item">
              <a class="nav__link" href="/product?Categoria=%2aVRF">
                <img
                  loading="lazy"
                  src="../../assets/icon-home-vrf.png"
                  alt="Categoria Ar-Condicionado VRF"
                />

                <span class="nav__title">VRF</span>
              </a>

              <!-- <div class="submenu">
                <div class="submenu__items">
                  <div class="submenu__group">
                    <h3>Tipo</h3>
                    <ul class="menu">
                        <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=%2aVRF">Condensadora VRF</a>
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=%2aVRF">Evaporadora VRF</a>
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=%2aVRF">Derivação em Y</a>
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=%2aVRF"
                          >Controle Remoto VRF</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenu__group">
                    <h3>Marca</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=%2aVRF&Marca=%2aLG">LG</a>
                      </li>
                    </ul>
                  </div>
                  <div class="submenu__group">
                    <h3>Ciclo</h3>
                    <ul class="menu">
                        <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=%2aVRF&Ciclo=Frio">Frio</a>
                      </li>
                      <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=%2aVRF&Ciclo=Quente%20e%20Frio"
                          >Quente e Frio</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div> -->
            </li>
            <li class="nav__item">
              <a class="nav__link" href="/product?Categoria=Portátil">
                <img
                  loading="lazy"
                  src="../../assets/icon-home-portatil.png"
                  alt="Categoria Ar-Condicionado Portátil"
                />

                <span class="nav__title">Ar Portátil</span>
              </a>

              <!-- <div class="submenu">
                <div class="submenu__items">
                  <div class="submenu__group">
                    <h3>Capacidade</h3>
                    <ul class="menu">
                        <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Portátil&Capacidade=7000-9000"
                          >9.000 BTUs</a
                        >
                      </li>
                      <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=Portátil&Capacidade=9001-12000"
                          >12.000 BTUs</a
                        >
                      </li>
                      <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=Portátil&Capacidade=12001-13000"
                          >13.000 BTUs</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenu__group">
                    <h3>Marca</h3>
                    <ul class="menu">
                  <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Portátil&Marca=%2aDelonghi"
                          >Delonghi</a
                        >
                      </li>
                    <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Portátil&Marca=%2aElgin"
                          >Elgin</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenu__group">
                    <h3>Ciclo</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Portátil&Ciclo=Frio">Frio</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div> -->
            </li>
            <li class="nav__item">
              <a class="nav__link" href="/product?Categoria=%2aClimatizador">
                <img
                  loading="lazy"
                  src="../../assets/icon-home-climatizador.png"
                  alt="Categoria Climatizadores"
                />

                <span class="nav__title">Climatizador</span>
              </a>

              <!-- <div class="submenu">
                <div class="submenu__items">
                  <div class="submenu__group">
                    <h3>Tipo</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Climatizador%20Industrial"
                          >Industrial</a
                        >
                      </li>
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Climatizador%20Residencial"
                          >Residencial</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenu__group">
                    <h3>Marca</h3>
                    <ul class="menu">
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=%2aClimatizador&Marca=%2aElgin"
                          >Elgin</a
                        >
                      </li>
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=%2aClimatizador&Marca=%2aMidea"
                          >Midea</a
                        >
                      </li>
                    <li class="menu__item">
                        <a
                          class="menu__link" href="/product?Categoria=%2aClimatizador&Marca=%2aVentisol"
                          >Ventisol</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="submenu__group">
                    <h3>Litros</h3>
                    <ul class="menu">
                      <li class="menu__item"><a class="menu__link" href="">7 Litros</a></li>
                      <li class="menu__item"><a class="menu__link" href="">10 Litros</a></li>
                      <li class="menu__item"><a class="menu__link" href="">20 Litros</a></li>
                      <li class="menu__item"><a class="menu__link" href="">45 Litros</a></li>
                      <li class="menu__item"><a class="menu__link" href="">65 Litros</a></li>
                      <li class="menu__item"><a class="menu__link" href="">70 Litros</a></li>
                      <li class="menu__item"><a class="menu__link" href="">100 Litros</a></li>
                    </ul>
                  </div>
                </div>
              </div> -->
            </li>
            <li class="nav__item">
              <a class="nav__link" href="/product?Categoria=Ventilador">
                <img
                  loading="lazy"
                  src="../../assets/icon-home-ventilador.png"
                  alt="Categoria Ventiladores"
                />

                <span class="nav__title">Ventilador</span>
              </a>

              <!-- <div class="submenu">
                <div class="submenu__items">
                  <div class="submenu__group">
                    <h3>Tipo</h3>
                    <ul class="menu">
                    <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Ventilador">Mesa</a>
                      </li>
                    <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Ventilador">Teto</a>
                      </li>
                    <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Ventilador">Parede</a>
                      </li>
                    <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Ventilador">Coluna</a>
                      </li>
                    <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Ventilador">Circulador</a>
                      </li>
                    <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Ventilador">Exaustor</a>
                      </li>
                    </ul>
                  </div>
                  <div class="submenu__group">
                    <h3>Marca</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a class="menu__link" href="/product?Categoria=Ventilador&Marca=%2aVentisol"
                          >Ventisol</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div> -->
            </li>
          </ul>
        </nav>

        <nav class="navbar" v-if="isSolar">
          <ul class="nav nav--solar">
            <li class="nav__item">
              <!-- <a href="#" class="nav__link">
                <img
                  loading="lazy"
                  src="../../assets/icon_hamburguer.png"
                  width="30px"
                  height="30px"
                  alt="Abrir Departamentos"
                />
                <span class="nav__title">Departamentos</span>
              </a> -->

              <div class="submenuDepartment submenuDepartment--solar">
                <div class="submenuDepartment__items">
                  <div
                    class="
                      submenuDepartment__group submenuDepartment__group--solar
                    "
                  >
                    <h3 class="submenuDepartment__title">Energia Solar</h3>
                    <ul class="menu">
                      <li class="menu__item">
                        <a
                          class="menu__link"
                          href="/product?Categoria=Kit%20Energia%20Fotovoltaica"
                          >Energia Fotovoltaica</a
                        >
                      </li>
                      <li class="menu__item">
                        <a
                          class="menu__link"
                          href="/product?Categoria=Itens%20Avulsos"
                          >Itens Avulsos</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </nav>

        <div class="sideMenu">
          <div class="loginWelcome" v-if="nomeUsuario == null">
            <div class="loginWelcome__image">
              <i class="fas fa-user"></i>
            </div>
            <div class="loginWelcome__description">
              <p>OLÁ VISITANTE</p>
              <p>
                Faça <span><router-link to="/login">Login</router-link></span> ou
                <span><router-link to="/register">Cadastre-se</router-link></span>
              </p>
            </div>
          </div>
          <div class="loginWelcome" v-if="nomeUsuario != null">
            <div class="loginWelcome__image">
              <i class="fas fa-user"></i>
            </div>
            <div class="loginWelcome__description">
              <h3>OLÁ {{ nomeUsuario }}</h3>
              <p>
                <span
                  ><router-link to="/account/orders"
                    >Minha Conta</router-link
                  ></span
                >
                ou
                <span
                  ><a href="javascript:void(0)" @click="deleteAllCookies"
                    >Sair</a
                  ></span
                >
              </p>
            </div>
          </div>
          <div class="menuMobile">
            <a href="javascript:void(0)" class="closebtn" @click="menuMobile"
              >&times;</a
            >
          </div>
        </div>
      </header>
    </div>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    carrinho: [],
    totalItensCarrinho: 0,
    cep: null,
    sla: null,
    precoFrete: null,
    slaSelecionado: null,
    totalCarrinho: 0,
    loader: false,
    nomeUsuario: null,
    token: null,
    isSolar: true,
    canalVendas: null,
    descricao: null,
    infoSKU: [],
    saleChannel: null,
    salesChannel: []
  }),
  methods: {
    changeChannel(channel) {
      // Atualiza canal logado
      localStorage.setItem("saleChannel", channel.IdCanal);
      localStorage.setItem("carrinho", []);
      
      window.location.href = `/`;
      
    },
    async getDados() {
      try {
        let dados = JSON.parse(localStorage.getItem("login"));
        this.nomeUsuario = dados.nomeUsuarioLogado;
        this.token = dados.token;

        let solar = JSON.parse(localStorage.getItem("isSaleSolar"));

        this.isSolar = solar;

        let saleChannel = parseInt(localStorage.getItem("saleChannel"));

        this.saleChannel = dados.canalvendas.filter(c => c.IdCanal === saleChannel);
        this.salesChannel = dados.canalvendas.filter(cv => cv.NomeCanal.toLowerCase().includes('solar -') && cv.IdCanal !== this.saleChannel[0].IdCanal)

        if (
          window.location.pathname == window.location.pathname &&
          this.token == null
        ) {
          window.location.href = `/login`;
        }
      } catch (e) {
        if (
          window.location.pathname == window.location.pathname &&
          this.token == null
        ) {
          window.location.href = `/login`;
        }

        console.log(e);
      }
    },

    montarMenuMobile() {
      if (window.innerWidth < 1050) {
        let navbarDesktop = document.querySelector(".submenuDepartment");
        let iconMenu = document.querySelector(".menuMobile");

        iconMenu.append(navbarDesktop);
      }
    },

    selecionaSLA(sla) {
      this.slaSelecionado = sla;
    },

    async calcularFrete() {
      this.loader = true;
      if (this.cep != null) {
        if (this.cep.length == 8) {
          let items = [];
          let carrinho = JSON.parse(localStorage.getItem("carrinho"));
          let saleschannel = JSON.parse(localStorage.getItem("saleChannel"));
          let quantidade_total = 0;
          this.canalVendas = saleschannel;
          carrinho.forEach(function (e) {
            let _items = {
              idSku: e.sku,
              quantidade: e.quantidade.toFixed(),
              price: e.valor * e.quantidade,
            };
            items.push(_items);
            quantidade_total = quantidade_total + e.quantidade;
          });
          let body = {
            location: {
              zipCode: this.cep.replace("-", ""),
            },
            saleschannel: saleschannel,
            items: items,
          };
          let simularFrete = await axios({
            method: "post",
            data: body,
            url: "https://www.leverosintegra.com.br/Map/api/ShippingSimulation/V2",
          }).then((res) => {
            return res.data;
          });
          this.loader = false;
          let sla = [];
          let valorFrete = [];
          if (simularFrete.freightSimulated.length > 0) {
            simularFrete.freightSimulated[0].slaResponseFreightSimulated.forEach(
              function (frete) {
                let preco_total = (frete.listPrice < frete.minimum_MoneyCost ? frete.minimum_MoneyCost : frete.listPrice);
                let pushSla = true;
                let _frete = {
                  preco: preco_total,
                  sla: frete.totalTime,
                  tipo: frete.slaType,
                  descricao: frete.slaTypeName,
                textoFrete: frete.slaTypeName !== 'Agendada' ? `${frete.slaType} - R$ ${preco_total
                  .toFixed(2)
                  .toString()
                  .replace(".", ",")} (Entrega em até ${
                  frete.totalTime
                } dias úteis)` : `${frete.slaType} - R$ ${preco_total
                  .toFixed(2)
                  .toString()
                  .replace(".", ",")} (Verificar datas disponíveis na tela de finalização)`,
                };
                // if (_frete.tipo == "Agendada") {
                //   _frete.textoFrete = `${_frete.tipo} - R$ ${(frete.listPrice < frete.minimum_MoneyCost ? frete.minimum_MoneyCost : frete.listPrice)
                //     .toFixed(2)
                //     .toString()
                //     .replace(".", ",")} (Entrega a combinar)`;
                // }
                if (sla.length == 0) {
                  pushSla = true;
                } else if (sla.find((x) => x.tipo == frete.slaType) != null) {
                  pushSla = false;
                }
                //Valida se Todos os produtos são atendidos pelo SLA disposto
                carrinho.forEach(function (c) {
                  let slaCart =
                    simularFrete.freightSimulated[0].slaResponseFreightSimulated.find(
                      (x) => x.itemId == c.sku && x.slaType == _frete.tipo
                    );
                  if (slaCart == null) {
                    pushSla = false;
                  } else if (_frete.tipo != "Agendada") {
                    c.sla = slaCart.totalTime;
                    c.valorFrete = (slaCart.listPrice < slaCart.minimum_MoneyCost ? slaCart.minimum_MoneyCost : slaCart.listPrice);
                  }
                });
                if (pushSla) {
                  sla.push(_frete);
                }
              }
            );
          }
          localStorage.setItem("carrinho", JSON.stringify(carrinho));
          this.sla = sla;
          this.precoFrete = valorFrete;
          this.recuperarInfosProdutos();
        }
      }
    },

    async calculaTotalCarrinho() {
      let total = 0;
      let carrinho = JSON.parse(localStorage.getItem("carrinho"));
      carrinho.forEach(function (e) {
        total = parseFloat(total) + parseFloat(e.quantidade);
      });

      this.totalItensCarrinho = total;
    },

    async recuperarInfosProdutos() {
      let carrinho = JSON.parse(localStorage.getItem("carrinho"));
      let totalCarrinho = 0;
      carrinho.forEach(function (c) {
        totalCarrinho =
          parseFloat(totalCarrinho) +
          parseFloat(c.valor) * parseFloat(c.quantidade);
      });
      this.totalCarrinho = totalCarrinho;
      this.carrinho = carrinho;
    },

    excluirProdutoCarrinho(sku) {
      let carrinho =
        localStorage.getItem("carrinho") != "" ||
        localStorage.getItem("carrinho") == null ||
        localStorage.getItem("carrinho") == undefined
          ? JSON.parse(localStorage.getItem("carrinho"))
          : [];

      carrinho.forEach(function (e, i) {
        if (e.sku == sku) {
          carrinho.splice(i, 1);
        }
      });

      if (carrinho.length == 0) {
        document.getElementsByClassName("minicart__closeMiniCart")[0].click();
        document.getElementsByClassName("header__quantity")[0].innerText = 0;
      }
      localStorage.setItem("carrinho", JSON.stringify(carrinho));
      this.calculaTotalCarrinho();
      this.recuperarInfosProdutos();
    },

    diminuirItensCarrinho(sku) {
      let carrinho =
        localStorage.getItem("carrinho") != "" ||
        localStorage.getItem("carrinho") == null ||
        localStorage.getItem("carrinho") == undefined
          ? JSON.parse(localStorage.getItem("carrinho"))
          : [];

      carrinho.forEach(function (e) {
        if (e.sku == sku) {
          if (e.quantidade > 1) {
            e.quantidade = e.quantidade - 1;
          }
        }
      });

      localStorage.setItem("carrinho", JSON.stringify(carrinho));
      this.calculaTotalCarrinho();
      this.recuperarInfosProdutos();
    },

    aumentarItensCarrinho(sku, estoque) {
      let carrinho =
        localStorage.getItem("carrinho") != "" ||
        localStorage.getItem("carrinho") == null ||
        localStorage.getItem("carrinho") == undefined
          ? JSON.parse(localStorage.getItem("carrinho"))
          : [];

      carrinho.forEach(function (e) {
        if (e.sku == sku) {
          if (e.quantidade < estoque) {
            e.quantidade = e.quantidade + 1;
          }
        }
      });

      localStorage.setItem("carrinho", JSON.stringify(carrinho));
      this.calculaTotalCarrinho();
      this.recuperarInfosProdutos();
    },

    closeMiniCart() {
      const miniCart = document.querySelector(".minicart");
      miniCart.classList.remove("minicart--active");
    },

    openMiniCart() {
      this.recuperarInfosProdutos();
      const miniCart = document.querySelector(".minicart");
      miniCart.classList.add("minicart--active");
    },

    addOverlay() {
      const overlay = document.getElementById("backgroundOverlay");
      const inputHeader = document.querySelector(".header__inputSearch");

      inputHeader.style.backgroundColor = "#fff";
      overlay.style.display = "block";
    },

    closeOverlay() {
      document.getElementsByClassName("result")[0].style.display = "none";
      document.getElementById("backgroundOverlay").style.display = "none";
      const inputHeader = document.querySelector(".header__inputSearch");

      inputHeader.style.backgroundColor = "#f3f3f3";
    },

    deleteAllCookies() {
      localStorage.clear();

      var url_string = window.location.href;
      var url = new URL(url_string);
      window.location.href = url.href;
    },

    menuMobile() {
      let menu = document.querySelector(".sideMenu");
      menu.classList.toggle("active");
    },

    showOptionsMenu() {
      if (window.innerWidth <= 768) {
        var groups = document.getElementsByClassName(
          "submenuDepartment__group"
        );

        for (let i = 0; i < groups.length; i++) {
          groups[i].addEventListener("click", function () {
            this.classList.toggle("active");
            var menus = this.children[1];
            if (menus.style.display === "block") {
              menus.style.display = "none";
            } else {
              menus.style.display = "block";
            }
          });
        }
      }
    },

    async getProduct() {
      try {
        let saleschannel = JSON.parse(localStorage.getItem("saleChannel"));
        this.canalVendas = saleschannel;

        let solar = JSON.parse(localStorage.getItem("isSaleSolar"));

        let body = {
          TabelaPreco: this.canalVendas,
          Descricao: `${this.descricao}`,
          isSaleSolar: solar,
          Departamentos: [],
          Categorias: [],
          Marcas: [],
          Geradores: [],
          Voltagens: [],
          Potencias: [],
        };

        const resp = await axios({
          method: "post",
          url: `https://www.leverosintegra.com.br/Map/Api/ProdutoLista?token=${this.token}`,
          data: body,
        });

        this.infoSKU = resp.data.lcardapio;

        document.getElementsByClassName("result")[0].style.display = "block";

        if (this.infoSKU.length == 0) {
          document.getElementsByClassName("result__void")[0].style.display =
            "block";
        } else {
          document.getElementsByClassName("result__void")[0].style.display =
            "none";
        }
      } catch (error) {
        console.log(error);
      }
    },

    productDetails(sku, preco, isCustomized) {
      localStorage.setItem(
        "precoDetails",
        JSON.stringify({ preco: preco, sku: sku })
      );

      // Controle de params
      let route = "";
      if (!this.isSolar) {
        route = `details?sku=${sku}`;
      } else if (isCustomized && this.isSolar) {
        route = `details?sku=${sku}&isCustomized=true&isSolar=true`;
      } else {
        route = `details?sku=${sku}&isSolar=true`;
      }

      window.location.href = route;
    },
  },

  mounted: function () {
    this.montarMenuMobile();
    this.showOptionsMenu();
  },

  beforeMount() {
    if (localStorage.getItem("carrinho") == null) {
      localStorage.setItem("carrinho", []);
    }
    this.recuperarInfosProdutos(), this.calculaTotalCarrinho(), this.getDados();
  },
};
</script>

<style lang="scss" scoped>
#backgroundOverlay {
  position: fixed;
  height: 100%;
  width: 100%;
  background: var(--customBlack);
  top: 0;
  left: 0;
  display: none;
  z-index: 999;
  opacity: 0.7;
}

.width {
  width: 35%;
}

.active {
  display: block !important;
}

.advantages {
  display: none;

  @media (min-width: 871px) {
    max-width: 100%;
    height: 30px;
    background-color: var(--customDarkGreen);
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  &__items {
    color: var(--customWhite);
    text-decoration: none;
    font: 700 0.75rem "Soleto", sans-serif;

    i {
      font-size: 1rem;
      margin-right: 5px;
    }
  }
}

.header {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  max-width: 90%;
  margin: 0 auto;
  padding-top: 20px;
  background-color: var(--customWhite);

  @media (max-width: 768px) {
    max-width: 100%;
  }

  @media (min-width: 1920px) {
    max-width: 70%;
  }

  &__iconMenu {
    display: none;
    cursor: pointer;

    @media (max-width: 1080px) {
      display: block;
      position: relative;
      top: 5px;
    }

    .menuHamburguer {
      width: 30px;
      height: 4px;
      background-color: var(--standardGreen);
      margin: 6px 0;
    }
  }

  &__logo {
    @media (max-width: 768px) {
      width: 75%;
    }
  }

  &__search {
    position: relative;
    @media (max-width: 768px) {
      padding: 20px 0 0 27px;
    }
  }

  &__inputSearch {
    font-size: 0.95rem;
    width: 305px;
    height: 37px;
    border-radius: 5px 5px 0 0;
    border: none;
    background-color: var(--customGray-70);
    outline: none;
    padding-left: 30px;
    position: relative;
    z-index: 100001;

    @media (min-width: 500px) {
      width: 462px;
    }
  }

  &__buttonSearch {
    position: relative;
    left: -40px;
    z-index: 100001;
    background-color: transparent;
    border: none;
    vertical-align: middle;
    outline: none;
    cursor: pointer;
  }

  .result {
    background: var(--customWhite);
    width: 305px;
    min-height: 100px;
    position: absolute;
    z-index: 9999;
    display: none;

    @media (min-width: 500px) {
      width: 462px;
    }

    &__item {
      padding: 10px 20px;

      a {
        text-decoration: none;
        color: var(--customDarkGreen);
        display: flex;
        align-items: center;
        cursor: pointer;

        &:hover {
          color: #7a7a7a;
        }

        img {
          width: 70px;
          max-width: 100%;
          height: auto;
        }
      }
    }

    &__void {
      display: none;
      text-align: center;
      margin-top: 30px;
      color: var(--customGray-500);
    }
  }

  &__account {
    display: flex;
    align-items: center;

    @media (max-width: 768px) {
      display: none;
      position: absolute;
      top: 32px;
      right: 90px;
    }
  }

  &__guest {
    padding-left: 15px;
    font-size: 0.95rem;
    line-height: 1.4;
    color: var(--customDarkGreen);

    p:nth-child(1) {
      font-weight: bold;
    }
  }

  &__guestOptions {
    @media (max-width: 1023px) {
      display: none;
    }

    a {
      color: var(--customDarkGreen);
      font-size: 0.875rem;

      &:hover {
        color: var(--customGray-100);
      }
    }
  }

  &__user {
    padding-left: 15px;
    line-height: 1.4;

    p {
      font: 800 0.95rem "Soleto", sans-serif;
      color: var(--customDarkGreen);
      white-space: nowrap;
      width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;

      @media (max-width: 1093px) {
        display: none;
      }
    }
  }

  &__userOptions {
    @media (max-width: 1023px) {
      display: none;
    }

    span {
      font-size: 0.875rem;

      &:nth-child(2) {
        @media (max-width: 768px) {
          display: none;
        }
      }
    }

    a {
      color: var(--customDarkGreen);
      font-size: 0.875rem;
      text-decoration: underline;

      @media (max-width: 1093px) {
        text-decoration: none;
      }

      &:hover {
        color: var(--customGray-500);
      }
    }
  }

  &__logout {
    text-decoration: underline;
    cursor: pointer;

    @media (max-width: 1093px) {
      text-decoration: none;
    }

    &:hover {
      color: var(--customGray-500);
    }
  }

  &__cart {
    display: flex;
    align-items: center;
    cursor: pointer;

    @media (max-width: 768px) {
      position: absolute;
      right: 0;
      top: 30px;
    }
  }

  &__cartGroup {
    font-size: 0.95rem;
    line-height: 1.4;
    color: var(--customDarkGreen);

    @media (max-width: 1093px) {
      display: none;
    }

    & p:nth-child(1) {
      font-weight: 800;
    }

    & p:nth-child(2) {
      font-weight: bold;
      text-decoration: underline;
    }
  }

  &__quantity {
    background: var(--customBlue);
    color: var(--customDarkGreen);
    width: 20px;
    height: 20px;
    border-radius: 10px;
    position: relative;
    left: -27px;
    top: -4px;
    text-align: center;
    font-weight: bold;
  }
}

.minicart {
  visibility: hidden;
  display: block;
  position: fixed;
  right: 0;
  top: 0;
  background: var(--customWhite);
  width: 100%;
  height: 100%;
  z-index: 9999999;
  overflow-y: auto;
  box-shadow: 0 4px 20px var(--customBlack);

  @media (min-width: 769px) {
    width: 35%;
  }

  &--active {
    width: 100% !important;
    z-index: 9999999 !important;
    visibility: visible !important;

    @media (min-width: 601px) {
      visibility: visible !important;
      width: 35% !important;
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid var(--customGray-100);

    h3 {
      color: var(--customDarkGreen);
    }

    i {
      font-size: 1.438rem;
      color: var(--customBlue);
      cursor: pointer;
    }
  }

  &__products {
    width: 100%;
    padding: 0 15px;
    height: calc(100% - 470px);
    overflow: auto;
  }

  &__item {
    display: flex;
    align-items: center;
    padding: 20px 0 0 0;
  }

  &__details {
    line-height: 1.7;
    width: 100%;

    p {
      font-size: 0.95rem;
      color: var(--customGray-500);
      padding: 0 30px 0 5px;
      width: 100%;

      &:nth-child(2) {
        color: var(--customDarkGreen);
        font: 700 0.975rem "Soleto", sans-serif;
      }
    }

    button {
      background: var(--standardGreen);
      color: var(--customWhite);
      width: 30px;
      height: 20px;
      margin: 7px;
      border-radius: 5px;
      outline: none;
      font: 700 0.95rem "Soleto", sans-serif;
    }

    span {
      color: var(--customDarkGreen);
      padding: 0 8px;
      font: 700 0.95rem "Soleto", sans-serif;
    }
  }

  &__iconTrash {
    position: relative;

    a i {
      font-size: 1.25rem;
      color: var(--customBlue);
    }
  }

  &__title {
    border-bottom: 1px solid var(--customGray-100);

    h3 {
      font-size: 1rem;
      color: var(--customDarkGreen);
      display: flex;
      align-items: center;
      justify-content: center;
      text-transform: uppercase;
      padding: 10px 0;
    }
  }

  &__calculate {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  &__input {
    border: 1px solid var(--customGray-200);
    border-radius: 5px;
    padding: 7px;
    margin-top: 10px;
    outline: none;
    font-size: 0.95rem;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  &__buttonSearch {
    position: relative;
    left: 65px;
    top: -26px;
    outline: none;
  }

  &__toKnowCEP {
    position: relative;
    top: -18px;
    left: 45px;
    text-decoration: none;

    a {
      color: var(--customGray-500);
      font-size: 0.7rem;
    }
  }

  &__options {
    padding: 10px 30px;
  }

  &__loader {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    i {
      color: var(--customBlue);
    }

    span:nth-child(2) {
      color: var(--customGray-800);
      font-size: 0.85rem;
      padding-top: 10px;
    }
  }

  &__totals {
    border-top: 1px solid var(--customGray-100);
    padding: 10px 0 25px 0;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 5px 30px;
      font-size: 0.95rem;
    }

    li span {
      color: var(--customGray-500);
      font-size: 0.95rem;
    }
  }

  &__buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px 0;

    a {
      text-decoration: none;
    }

    &--cart {
      border: 1px solid var(--customDarkGreen);
      padding: 7px;
      border-radius: 5px;
      color: var(--customDarkGreen);
      font: 700 0.95rem "Soleto", sans-serif;
      outline: none;

      &:hover {
        color: var(--standardGreen);
      }
    }

    &--buy {
      background: var(--standardGreen);
      color: var(--customWhite);
      padding: 7px;
      border-radius: 5px;
      margin-left: 20px;
      font: 700 0.95rem "Soleto", sans-serif;
      outline: none;
    }
  }
}

.navbar {
  .nav {
    max-width: 90%;
    margin: 0 auto;
    padding-top: 30px;
    display: none;

    @media (min-width: 1081px) {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    @media (min-width: 1920px) {
      max-width: 70%;
    }

    &--solar {
      max-width: 87%;

      @media (min-width: 1081px) {
        justify-content: flex-start;
      }
    }

    &__item {
      list-style: none;
      width: 8.5%;
      position: relative;

      &:hover {
        .submenu,
        .submenuDepartment {
          display: block;
        }
        img {
          position: relative;
          top: -5px;
        }

        .nav__title {
          color: var(--customGray-800);
        }
      }

      .submenuDepartment {
        background: var(--customGray-50);
        border-radius: 5px;
        box-shadow: 0 4px 10px var(--customGray-500);
        position: absolute;
        z-index: 99999;
        display: none;
        width: 1140px;

        &--solar {
          width: 300px;
        }

        &__items {
          display: flex;
          flex-wrap: wrap;
          padding: 20px 10px;
        }

        &__group {
          width: 20%;
          padding: 15px;

          &--solar {
            width: inherit;
          }

          h3 {
            font-size: 1rem;
          }

          .menu {
            padding-top: 15px;
            &__item {
              list-style: none;
              line-height: 1.6;
            }

            &__link {
              text-decoration: none;
              color: var(--customDarkGreen);
              font-size: 0.95rem;

              &:hover {
                color: var(--standardGreen);
              }
            }
          }
        }
      }

      .submenu {
        background: var(--customGray-50);
        border-radius: 5px;
        box-shadow: 0 4px 10px var(--customGray-500);
        position: absolute;
        z-index: 99999;
        display: none;
        left: auto;
        right: -87px;
        min-width: 100%;

        &__items {
          display: flex;
          padding: 20px 10px;
        }

        &__group {
          padding: 0 25px;

          h3 {
            font-size: 0.95rem;
          }

          .menu {
            padding-top: 15px;
            &__item {
              list-style: none;
              line-height: 1.6;
            }

            &__link {
              text-decoration: none;
              color: var(--customDarkGreen);
              font-size: 0.95rem;

              &:hover {
                color: var(--standardGreen);
              }
            }
          }
        }
      }
    }

    &__link {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-decoration: none;
    }

    &__title {
      text-align: center;
      color: var(--customDarkGreen);
      padding-top: 5px;
      font: 700 0.95rem "Soleto", sans-serif;
    }
  }
}

.sideMenu {
  background: var(--customGray-70);
  position: absolute;
  top: 0;
  width: 80%;
  height: 100%;
  z-index: 999999;
  left: 0;
  display: none;
  animation: slideMenu 0.45s;

  @keyframes slideMenu {
    from {
      width: 0%;
    }
    to {
      width: 80%;
    }
  }

  .loginWelcome {
    background: var(--standardGreen);
    display: flex;
    align-items: center;
    padding: 20px;

    &__image {
      i {
        color: var(--customWhite);
        font-size: 2rem;
      }
    }

    &__description {
      padding-left: 10px;
      h3 {
        white-space: nowrap;
        width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 0.95rem;
        color: var(--customWhite);
        padding-bottom: 5px;
      }

      p {
        color: var(--customWhite);
        font-size: 0.95rem;

        span {
          a {
            color: var(--customWhite);
          }
        }
      }
    }
  }

  .menuMobile {
    padding: 30px 20px;

    .closebtn {
      position: absolute;
      top: 18px;
      right: 23px;
      color: var(--customWhite);
      text-decoration: none;
      font: 800 2.7rem "Soleto", sans-serif;
    }

    .submenuDepartment {
      &__group {
        padding: 10px 0;
        h3 {
          font-size: 1rem;
          color: var(--customGray-500);
          &::after {
            content: "\f054";
            font-family: "FontAwesome";
            font-size: 0.95rem;
            color: var(--customGray-500);
            float: right;
            margin: 5px;
          }
        }

        .menu {
          padding: 10px 0;
          display: none;

          &__item {
            list-style: none;
            line-height: 1.6;
          }

          &__link {
            color: var(--customGray-800);
            text-decoration: none;
            font-size: 1rem;
          }
        }
      }
    }
  }
}

::v-deep .v-application--wrap {
  min-height: fit-content;
}

.v-tooltip__content {
  opacity: 1 !important;
}
</style>